/**
 * Imports
 */

import { xterm } from '@remotex-labs/xansi/xterm.component';

/**
 * Style token for successful/OK messages (green).
 *
 * @since 2.0.0
 */

export const okColor = xterm.hex('#80a36b');

/**
 * Base text color token (neutral light).
 *
 * @since 2.0.0
 */

export const textColor = xterm.hex('#dcdfe4');

/**
 * Style token for informational messages (blue).
 *
 * @since 2.0.0
 */

export const infoColor = xterm.hex('#5798cd');

/**
 * Style token for warnings (yellow).
 *
 * @since 2.0.0
 */

export const warnColor = xterm.hex('#e5c07b');

/**
 * Style token for file paths, URLs, and locations (cyan).
 *
 * @since 2.0.0
 */

export const pathColor = xterm.hex('#56b6c2');

/**
 * Style token for errors and failures (red).
 *
 * @since 2.0.0
 */

export const errorColor = xterm.hex('#e06c75');

/**
 * Style token for highlighted keywords and identifiers (purple).
 *
 * @since 2.0.0
 */

export const keywordColor = xterm.hex('#c678dd');

/**
 * Style token for de-emphasized / secondary text (muted gray).
 *
 * @since 2.0.0
 */

export const mutedColor = xterm.hex('#a5a7ab');
